import {useEffect, useState} from 'react';

import {Success} from 'common/models/success';
import {useNavigate} from 'react-router-dom';
import {useFormUrl} from 'ui/hooks/useFormUrl';
import {sendPageInfo} from 'ui/utils/postMessages';
import redirectToExternalUrl from 'ui/utils/redirectToExternalUrl';

const defaultPaymentParams = {
    paymentType: 'PC',
    'quickpay-form': 'shop',
};
export const {
    iframe,
    routes: {paymentUrl},
} = window.YC;

const useSuccessRedirect = (
    answerKey: string | null,
    successData: Success,
    isPreparedData: boolean,
) => {
    const formUrl = useFormUrl();
    const navigate = useNavigate();

    const [buttonPaymentUrl, setButtonPaymentUrl] = useState<string>();

    useEffect(() => {
        if (!answerKey) {
            navigate(formUrl);
        }
        if (!isPreparedData) {
            return;
        }
        if (iframe) {
            sendPageInfo('messages-iframe');
            if (successData.results) {
                sendPageInfo('correct-answers-iframe');
            }
            if (successData.total_scores) {
                sendPageInfo('quiz-results-iframe');
            }
            if (successData.redirect?.auto_redirect) {
                sendPageInfo('redirect-iframe');
            }
        }

        if (successData.payment) {
            const fullPaymentUrl = new URL(paymentUrl);
            const paymentParams = new URLSearchParams({
                label: successData.payment.label,
                receiver: successData.payment.receiver,
                sum: String(successData.payment.sum),
                targets: successData.payment.targets,
                successURL: window.location.href,
                ...defaultPaymentParams,
            });
            const fullPaymentUrlString = `${fullPaymentUrl}?${paymentParams}`;

            setButtonPaymentUrl(fullPaymentUrlString);
            try {
                redirectToExternalUrl(fullPaymentUrlString);
            } catch (e) {}
        }
    }, [isPreparedData, successData, answerKey, navigate, formUrl]);
    return [buttonPaymentUrl];
};
export default useSuccessRedirect;
